import momentJalaali from "moment-jalali";
import Loader from "react-loader-spinner";
import { useForm } from "react-hook-form";
import DatePicker from "react-datepicker2";
import "react-datepicker2/src/styles/style.css";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Card, Col, Row } from "react-bootstrap";
import { useHistory, useParams } from "react-router-dom";
import BihamtaTable from "../../Components/BihamtaTable";
import { accountsBookReport } from "../store/api/DocumentsAPI";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBookOpen } from "@fortawesome/free-solid-svg-icons";
import ModalSelectCostCenter from "../Components/ModalSelectCostCenter";
import { exportToExcel, keyIsLetterOrNumber } from "../../store/api/CommonFunctions";
import { FileEarmarkExcelFill, List, PrinterFill, Search, BookmarkFill } from "react-bootstrap-icons";
import ModalAccountLevel3 from "../../Components/Modals/ModalAccountLevel3";
import ModalAccountsLevel2 from "../Components/ModalAccountsLevel2";
import ModalAccountsLevel1 from "../Components/ModalAccountsLevel1";
import ModalAccountsLevel0 from "../Components/ModalAccountsLevel0";
import ModalAccountCheck from "../Components/ModalAccountCheck";

const AccountingBook = () => {
    const { accountID, accountCat, level } = useParams();
    const levelNames = ["گروه", "کل", "معین", "تفصیلی"];


    const total = useRef({});
    const history = useHistory();
    const dispatch = useDispatch();
    const { handleSubmit, register } = useForm();
    const [pending, setPending] = useState(false);
    const [showColor, setColorShow] = useState(false);
    const [selectedAccount, selectAccount] = useState(null);
    const [selectedCostCenter, selectCostCenter] = useState(null);
    const [popAccCheck, setPopAccCheck] = useState({ show: false });
    const [popAccLevel0, setPopAccLevel0] = useState({ show: false });
    const [popAccLevel1, setPopAccLevel1] = useState({ show: false });
    const [popAccLevel2, setPopAccLevel2] = useState({ show: false });
    const [popAccLevel3, setPopAccLevel3] = useState({ show: false });
    const [popCostCenter, setPopCostCenter] = useState({ show: false });
    const { list, filterData } = useSelector(state => { return { list: state.DocumentReducer.accBookReport, filterData: state.DocumentReducer.accBookFilters } });
    const [dateFilters, setDateFilters] = useState({
        DateFrom: filterData.DateFrom,
        DateTo: filterData.DateTo
    })
    if (list?.Data && Array.isArray(list.Data)) {
        total.current.Debit = list.Data.map(l => l.Debit).reduce((a, b) => a + b, 0);
        total.current.Credit = list.Data.map(l => l.Credit).reduce((a, b) => a + b, 0);
        total.current.RemainedDebit = total.current.Debit - total.current.Credit;
        if (Number(accountID) > 0) {
            if (Number(level) === 3 && !selectedAccount) {
                const acc = list.Data.find(l => Number(l.AccountID) === Number(accountID) & Number(l.AccountCat) === Number(accountCat));
                if (acc) {
                    selectAccount({ AccountCat: acc.AccountCat, AccountID: acc.AccountID, AccountName: acc.AccountNameLThree, AccountCode: acc.AccountCodeLThree });
                }
            }
            else if (Number(level) === 2 && !selectedAccount) {
                const acc = list.Data.find(l => Number(l.AccountIDLTwo) === Number(accountID));
                if (acc) {
                    selectAccount({ AccountID: acc.AccountIDLTwo, AccountName: acc.AccountNameLTwo, AccountCode: acc.AccountCodeLTwo });
                }
            }
        }
    }
    else {
        total.current.Debit = total.current.Credit = total.current.RemainedCredit = total.current.RemainedDebit = 0;
    }
    function search(data) {
        data.Skip = 0;
        data.Level = level;
        if (!data.Take) {
            data.Take = 10;
        }
        const pDateFrom = document.getElementsByName("DateFrom")[0].value;
        //For Print
        data.PDateFrom = pDateFrom;
        //
        if (pDateFrom !== "") {
            data.DateFrom = dateFilters.DateFrom;
        }
        const pDateTo = document.getElementsByName("DateTo")[0].value;
        //For Print
        data.PDateTo = pDateTo;
        //
        if (pDateTo !== "") {
            data.DateTo = dateFilters.DateTo;
        }
        dispatch(accountsBookReport(data));

    }
    const tableColes = [
        { colTitle: "ردیف", colName: "RowNumber", showInMobile: true },
        { colTitle: "حساب تفصیلی", colName: "AccountNameLThree", showInMobile: true, showCondition: () => Number(level) === 3 && !(Number(selectedAccount?.AccountID) > 0) },
        { colTitle: "حساب معین", colName: "AccountNameLTwo", showInMobile: true, showCondition: () => Number(level) === 2 && !(Number(selectedAccount?.AccountID) > 0) },
        { colTitle: "حساب کل", colName: "AccountNameLOne", showInMobile: true, showCondition: () => Number(level) === 1 && !(Number(selectedAccount?.AccountID) > 0) },
        { colTitle: "حساب گروه", colName: "AccountNameLO", showInMobile: true, showCondition: () => Number(level) === 0 && !(Number(selectedAccount?.AccountID) > 0) },
        { colTitle: "تاریخ سند", colName: "PDocumentDate", showInMobile: true },
        { colTitle: "شماره سند", colName: "DocumentNumber", showInMobile: true },
        { colTitle: "شرح ردیف", colName: "RowDescription", showInMobile: true, colType: "string", maxLength: 300 },
        { colTitle: "بدهکار", colName: "Debit", showInMobile: false, colType: "currency" },
        { colTitle: "بستانکار", colName: "Credit", showInMobile: false, colType: "currency" },
        { colTitle: "مانده", colName: "RemainedDebit", showInMobile: false, colType: "currency", style: { direction: "ltr" } },
        { colTitle: "بدهکار/بستانکار", colName: "PRowAccountType", showInMobile: false },
        { colTitle: " ", colName: "AccCheckColor", colType: "color", showInMobile: false, showCondition: () => showColor },
        { colTitle: "شرح بررسی", colName: "AccCheckDescription", colType: "color", showInMobile: false, showCondition: () => 0 === 1 }
    ];
    const tableRowButtons = [
    ]
    if (showColor) {
        tableRowButtons.push({
            title: "توضیحات", tooltip: "توضیحات ردیف", type: "common", className: "group-Btn-smalll btn-primary", onclick: showModalAccountCheck, icon: <BookmarkFill color="#811849" size={18} className="rowBtn" />
        })
    }
    function rowClick(row) {
        history.push(`/Accounting/AddEditDocument/${row.DocumentID}`);

    }
    function toExcel() {
        const url = "api/DocumentsAPI/AccountingBook";
        const searchArgs = { ...filterData };
        searchArgs.Take = 0;
        setPending(true);
        exportToExcel("AccountingBookL" + level, searchArgs, url, "post", tableColes, () => setPending(false));
    }
    function printReport(e) {
        const searchArgs = { ...filterData };
        searchArgs.Take = 0;
        searchArgs.Skip = 0;
        history.push({
            pathname: `/PrintViewer/AccountingBookL${level}/${e.ctrlKey}`,
            state: {
                dataUrl: `api/DocumentsAPI/AccountingBook`,
                method: "post",
                fetchBody: JSON.stringify(searchArgs)
            }
        });
    }
    function showModalCostCenter(e) {
        if (e.key) {
            if (!keyIsLetterOrNumber(e.keyCode, e.key)) {
                return;
            }
            e.preventDefault();
        }
        const onSelect = (data) => {
          filterData.CostCenterName =  filterData.CostCenterID = null;
            selectCostCenter(data);
        }
        setPopCostCenter({
            show: true,
            onSelect: onSelect
        });

    }
    function showModalAccLevel(e) {
        if(Number(accountID) > 0 && Number(accountCat) > 0)
        {
            return;
        }
        if (e.key) {
            if (!keyIsLetterOrNumber(e.keyCode, e.key)) {
                return;
            }
            e.preventDefault();
        }
        const onSetData = (data) => {
            filterData.AccountName = filterData.AccountCat = filterData.AccountID = null;
            selectAccount(data);
        }

        if (Number(level) === 3) {
            setPopAccLevel3({ show: true, setAccData: onSetData, value: e.key });
        }
        if (Number(level) === 2) {
            setPopAccLevel2({ show: true, setAccData: onSetData, value: e.key });
        }
        if (Number(level) === 1) {
            setPopAccLevel1({ show: true, setAccData: onSetData, value: e.key });
        }
        if (Number(level) === 0) {
            setPopAccLevel0({ show: true, setAccData: onSetData, value: e.key });
        }
    }
    function showModalAccountCheck(row) {
        setPopAccCheck({ show: true, checkType: "AccBookLevel" + level, relationID: row.RowID, onSave: search });
    }
    useEffect(() => {
        document.body.classList = "notMain";
        document.title = "بی همتا-امور مالی";
        selectCostCenter(null);
        selectAccount(null);
        //To Prevent Searching Again When We Return To The Search Page From The Opened Document
        if (!filterData?.AccountID || Number(filterData?.Level) !== Number(level) || Number(filterData.AccountID) !== Number(accountID) || Number(filterData.AccountCat) !== Number(accountCat)) {//
            const data={};
            data.AccountID = accountID ?? 0;
            data.AccountCat = accountCat ?? 0;
            data.GetColor = showColor;
            search(data);
        }
    }, [level, accountID, accountCat]);
    return (
        <div className="container-fluid mt-2">
            <br />
            <ModalAccountCheck popData={popAccCheck} setPopData={setPopAccCheck} />
            {Number(level) === 0 && <ModalAccountsLevel0 popData={popAccLevel0} setPopData={setPopAccLevel0} />}
            {Number(level) === 1 && <ModalAccountsLevel1 popData={popAccLevel1} setPopData={setPopAccLevel1} />}
            {Number(level) === 2 && <ModalAccountsLevel2 popData={popAccLevel2} setPopData={setPopAccLevel2} />}
            {Number(level) === 3 && <ModalAccountLevel3 popData={popAccLevel3} setAccLevel3Popup={setPopAccLevel3} />}
            <ModalSelectCostCenter popData={popCostCenter} setPopCostCenter={setPopCostCenter} />
            <Card>
                <Card.Header className="headerStyle">
                    <FontAwesomeIcon icon={faBookOpen} size="lg" />
                    &nbsp;
                    دفتر حساب {levelNames[level]}
                </Card.Header>
                <Card.Body className="bodyStyle">
                    <form onSubmit={handleSubmit(search)}>
                        <Row className="rowBorder">
                            <Col md={2} className="form-group">
                                <label>از تاریخ: </label>
                                <DatePicker className="form-control" isGregorian={false} timePicker={false} name="DateFrom"
                                    value={dateFilters?.DateFrom ? momentJalaali(dateFilters?.DateFrom) : null}
                                    onChange={value => setDateFilters({ ...dateFilters, DateFrom: value.local("en").format("YYYY-MM-DD") })} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>تا تاریخ: </label>
                                <DatePicker className="form-control" isGregorian={false} timePicker={false} name="DateTo"
                                    value={dateFilters?.DateTo ? momentJalaali(dateFilters.DateTo) : null}
                                    onChange={value => setDateFilters({ ...dateFilters, DateTo: value.local("en").format("YYYY-MM-DD") })} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>حساب {levelNames[level]}</label>
                                <input type="hidden" name="AccountCat" ref={register({})} readOnly value={selectedAccount?.AccountCat ?? filterData?.AccountCat ?? ""} />
                                <input type="hidden" name="AccountID" ref={register({})} readOnly value={selectedAccount?.AccountID ?? filterData?.AccountID ?? ""} />
                                <input type="text" className="form-control" name="AccountName" ref={register({})}
                                    value={selectedAccount?.AccountName ?? filterData?.AccountName ?? ""} onKeyDown={showModalAccLevel} readOnly />
                                <Button className="btn-input-tiny" onClick={showModalAccLevel} disabled={Number(accountID) > 0 && Number(accountCat) > 0}><List size={20} /></Button>
                            </Col>
                            <Col md={2} className="form-group">
                                <label>مرکز هزینه</label>
                                <input type="hidden" readOnly value={selectedCostCenter?.ID ?? filterData?.CostCenterID ?? ""} name="CostCenterID" ref={register({})} />
                                <input type="text" className="form-control" onKeyDown={showModalCostCenter} readOnly name="CostCenterName" ref={register({})}
                                    value={selectedCostCenter?.CenterName ?? filterData?.CostCenterName ?? ""} />
                                <Button className="btn-input-tiny" style={{ top: "26.5px" }}><List size={20} onClick={showModalCostCenter} /></Button>
                            </Col>
                            <Col md={2} className="form-group">
                                <label>تعداد در صفحه</label>
                                <select className="form-control" ref={register({})} name="Take" defaultValue={filterData?.Take ?? 10}>
                                    <option value={0}>انتخاب کنید</option>
                                    <option value={10}>10</option>
                                    <option value={20}>20</option>
                                    <option value={50}>50</option>
                                    <option value={100}>100</option>
                                </select>
                            </Col>
                            <Col md={2} className="form-group">
                                <label>مرتب سازی بر اساس</label>
                                <select className="form-control" ref={register({})} name="SortBy" defaultValue={filterData?.SortBy ?? ""}>
                                    <option value="">انتخاب کنید</option>
                                    <option value="Date">تاریخ سند</option>
                                    <option value="Date DESC">تاریخ سند-نزولی</option>
                                    <option value="DocumentNumber">شماره سند</option>
                                    <option value="DocumentNumber DESC">شماره سند-نزولی</option>
                                </select>
                            </Col>
                            <Col md={2} className="form-group">
                                <input type="checkbox" name="GetColor" ref={register({})} className="form-check-input" onChange={e => setColorShow(e.target.checked)} />
                                &nbsp;
                                <label style={{ color: "blue", marginTop: "2px" }}>نمایش رنگ ها</label>
                            </Col>
                        </Row>
                        <Col md={3}>
                            <Button type="submit" className="group-Btn-large mt-3"><Search size={15} />&nbsp;نمایش دفتر حساب</Button>
                        </Col>
                    </form>
                    {!pending &&
                        <div style={{ padding: 0, width: "100%", textAlign: "left", marginTop: "5px" }}>
                            <FileEarmarkExcelFill onClick={toExcel} size={25} color="green" style={{ cursor: "pointer" }} className="hoverIcon" />
                            <PrinterFill color="blue" size={25} style={{ cursor: "pointer" }} className="hoverIcon" onClick={printReport} />
                        </div>}
                    {pending && <div style={{ padding: 0, width: "100%", textAlign: "left" }}><Loader type="BallTriangle" color="#bb1370" height={18} style={{ textAlign: "left", alignItems: "left" }} /></div>}
                    <BihamtaTable columns={tableColes} rowButtons={tableRowButtons} filterData={filterData} rowClick={rowClick} hasPaging={true} maxHeight={500} className="mb-0 mt-0"
                        searchMethod={(data) => dispatch(accountsBookReport(data))} reducerName="DocumentReducer" objectName="accBookReport" />
                    <table>
                        <thead>
                            <tr>
                                <th>بدهکار</th>
                                <th>بستانکار</th>
                                <th>مانده</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <input className="tableRowInput" style={{ color: "red" }} value={total.current.Debit?.toLocaleString(navigator.languages)} readOnly />
                                </td>
                                <td>
                                    <input className="tableRowInput" style={{ color: "blue" }} value={total.current.Credit?.toLocaleString(navigator.languages)} readOnly />
                                </td>
                                <td>
                                    <input className="tableRowInput" style={{ color: total.current.RemainedDebit > 0 ? "red" : "blue", direction: "ltr", textAlign: "right" }} value={total.current.RemainedDebit?.toLocaleString(navigator.languages)} readOnly />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </Card.Body>
            </Card>
        </div>
    )

}
export default AccountingBook;